import { render, staticRenderFns } from "./TipoProblemaForm.vue?vue&type=template&id=ca831e3e"
import script from "./TipoProblemaForm.vue?vue&type=script&lang=js"
export * from "./TipoProblemaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports